export const intlFormat = (num: number): string => new Intl.NumberFormat().format(Math.round(num * 10) / 10);

// gives number in 1K,1M ... format
export const makeNumber = (num: number): string => {
	if (num >= 1000000) return intlFormat(num / 1000000) + 'M';
	if (num >= 1000) return intlFormat(num / 1000) + 'k';
	return intlFormat(num);
};
